import { Component, ElementRef, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { CompetenciesService } from "../competencies.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CompetencyData } from "src/app/Models/competencyModel.model";
import { SkillRepoEmployeesService } from '../../skill-repo-employees/skill-repo-employees.service';
import { OthersService } from "../others/othersDataService";
import { SidebarModel } from "src/app/Models/OthersWidgetModel";
import { ToastrService } from "ngx-toastr";
import { url } from "inspector";
import { Partnership } from "../competency/partnership-creation-component/partnership-creation-component.component";
import { MatTableDataSource } from "@angular/material/table";
import { ProposalRepositoryService } from '../../proposal-repository/proposal-repository.service';
import { CMFService } from "src/app/services/CMFDashboard/CMFService";
import { Session } from "protractor";
import{ResourcesComponent} from '../resources/resources.component';
import { SharedSkillService } from '../../skill-repository/shared-skill.service';
import { forkJoin } from "rxjs";
 

// interface CheckboxItem {
//   id: number;
//   label: string;
//   selected: boolean;
// }

@Component({
  selector: "app-sub-competency",
  templateUrl: "./sub-competency.component.html",
  styleUrls: ["./sub-competency.component.css"],
})

export class SubCompetencyComponent implements OnInit {
  dataSource: any[] = [];
  subcompetencyLevelData: any;
  competencyLevelData: any;
  displayDropdown: Boolean = false;
  showPopup: boolean = false;
  orgHideit: boolean = true;
  showSubCompetency: boolean = false;
  hideIt: boolean = false;
  // org_data: any = [  
  //   {
  //     'name': 'Capacity', 'sub': [
  //       { 'name': 'Deployable content' },
  //       { 'name': 'Aglity to Scale' },
  //       { 'name': 'SCore Team' },
  //     ]
  //   },
  //   {
  //     'name': 'Capabilities', 'sub': [
  //       { 'name': 'Skill Diversity' },
  //       { 'name': 'certifications' },
  //       { 'name': 'Tools & FrameWorks' },
  //     ]
  //   },
  //   {
  //     'name': 'Marketing', 'sub': [
  //       { 'name': 'Paternships' },
  //       { 'name': 'Demoable Content' },
  //       { 'name': 'Case Studies' },
  //       { 'name': 'Blogs/white papers' },
  //       { 'name': 'Keynote Sessions' },
  //       { 'name': 'Customer References' },
  //     ]
  //   },
  // ];
  // checkboxesKPIs: CheckboxItem[] = [
  //   { id: 1, label: "Resource Avaliable", selected: false },
  //   { id: 2, label: "Certified Engineers", selected: false },
  //   { id: 3, label: "Subject Matter Expertise", selected: false },
  //   { id: 4, label: "Trainings", selected: false },
  // ]

  // checkboxesWidgets: CheckboxItem[] = [

  //   { id: 1, label: 'certifications', selected: false },
  //   { id: 3, label: 'trainings', selected: false },
  //   { id: 4, label: 'others', selected: false },
  //   { id: 6, label: 'resource', selected: false },
  // ];
  maxIndex: boolean = false;
  filterdata: any;
  competencyname: string;
  subCompetencyName: string;
  loading: boolean = false; 
  data: any;
  id: any;
  showDialogue: boolean = false;
  yearlyOptions: number[] = [];
  kpiarray: Array<any> = [];
  quarterNo: number = 1;
  yearData = [2023, 2024, 2025, 2026];
  year: number = 2023;
  subcompname: string;
  compname: string;
  competencyId: number;
  subcomp: string;
  intialsubcomp: string;
  applyKPIs = false;
  applyWidgets = false;
  tabs: SidebarModel[] = [];
  certificationCount: number = 0;
  resourceCount: number = 0;
  smeCount: number = 0;
  proposalCount:number = 0;
  interviewCount:number = 0; 
  public competencyData: CompetencyData = new CompetencyData();
  solutionByVertical: any[];
  CMFDashBoardData: any = {};
  constructor(private _service: CompetenciesService, private service: SkillRepoEmployeesService,
      private router: Router, private others: OthersService,  
    private Compservice: CompetenciesService,
    private proposalService: ProposalRepositoryService,private cmfService:CMFService)  { }
    
    // toggleFlag() {
    //   this.showSubCompetency = !this.showSubCompetency
    // }
   
  ngOnInit() { 
   // this.getcompetencyId();
    forkJoin({
      competencyName: this.Compservice.competencyName$,
      subCompetencyName: this.others.name$,
      profileStatus: this._service.profileStatus$,
      compname: this._service.competencyName$,
      subcompname: this.others.name$
    }).subscribe(({ competencyName, subCompetencyName, profileStatus, compname, subcompname }) => {
      this.competencyname = competencyName || sessionStorage.getItem("compTitle");
      this.subCompetencyName = subCompetencyName || sessionStorage.getItem("SubcompTitle");
      this.id = profileStatus || Number(sessionStorage.getItem("compId"));
      this.compname = compname;
      this.subcompname = subcompname || this.intialsubcomp;

      this.BindCMFDashboardData();
    });

    //this.getKPIs();
    //this.getWidgets();
    // this.service.getSubCompetenciesForDropDowns(this.id).subscribe(res => {
    //   this.tabs = res.data;
    //   this.intialsubcomp = this.tabs[0].name
    //   //this.call();
    // });
    forkJoin([
      this.service.GetResourcesCount(sessionStorage.getItem("compId")),
      this.service.GetSMECount(sessionStorage.getItem("compId")),
      this.service.getCertificateCount(sessionStorage.getItem("compId"), 0),
      this.service.GetSolutionByVertical(sessionStorage.getItem("compId"))
    ]).subscribe(
      ([resources, smeCount, certificateCount, solutions]) => {
      this.resourceCount = resources;
      this.smeCount = smeCount.length;
      this.certificationCount = certificateCount.data.completedCertificateCount;
      this.solutionByVertical = solutions;
      },
      error => {
      console.error("Error loading data:", error);
      }
    );
    

    // this.Compservice.serviceId$.subscribe(serviceId => {
    //   if (serviceId) {
        
    //   this.resourceComponent.resourceWidgetData=this.resourceComponent.getResourceWidgetCount(serviceId);
    //   }
    // });
     this.loading=false;

  }
BindCMFDashboardData() {  
  const comptitle = sessionStorage.getItem("compTitle"); 
  const serviceArea = sessionStorage.getItem("SubcompTitle");
  const compid = sessionStorage.getItem("compId");
  const subcompid = sessionStorage.getItem("SubcompId");
  console.log("serviceArea",serviceArea); 
  
  
const Params = {compId:Number(sessionStorage.getItem("compId")),serviceArea: sessionStorage.getItem("SubcompTitle")};
 const Data= JSON.stringify(Params);
  forkJoin({
    dashboardData: this.cmfService.GetCMFDashboardData(Params),
    interviews: this.cmfService.getCMFInterviewData()
  }).subscribe(
    ({ dashboardData, interviews }) => {
      this.CMFDashBoardData = dashboardData;
      this.proposalCount = dashboardData.proposalCount;
      this.interviewCount = interviews.filter(
        x => x.competencyId == compid && x.subCompetencyId == subcompid
      ).length;
 
    },
    error => {
      console.error("Error loading data:", error); 
    }
  );
}

  getSMECount() {
    const id = sessionStorage.getItem("compId");
    var count = 0;
    this.service.GetSMECount(id).subscribe((res) => {
      count = res.length;
      this.smeCount = count;
    })
  }
  navigateToProposals() {
    const navigationExtras = {
      compTitle: sessionStorage.getItem("compTitle"),
      serviceLine: sessionStorage.getItem("SubcompTitle"),
    };
    this.router.navigate(['Home/Proposal Repository'], { queryParams: navigationExtras });
  }
  updateServiceLine(event) {
  console.log("event", event);
  this.BindCMFDashboardData();
  }
  getProposalsCount() {    
    this.proposalService.getAllProposals('').subscribe(x => {      
      const comptitle = sessionStorage.getItem("compTitle"); 
        const serviceArea = sessionStorage.getItem("SubcompTitle");
        this.proposalCount= x.data.proposals.filter(x => x.competency.includes(comptitle)&&x.serviceLine.includes(serviceArea)).length;
    })
  }

  getInterviewsData() {  
      this.cmfService.getCMFInterviewData().subscribe(data => {
      const compid = sessionStorage.getItem("compId");
      const subcompid = sessionStorage.getItem("SubcompId");
      this.interviewCount = data.filter(x => x.competencyId == compid&&x.subCompetencyId==subcompid).length;
      
    })
  } 
  getcompetencyId() {
    // var url = this.router.url.split('/');
    // var name = url[3].replace(/%20/g, ' ');
    // this._service.getCompetenciesData().subscribe((res) => {
    //   var s = res.data.find((element) => element.name === name);
    //   sessionStorage.setItem("compId", s.id);
    //   sessionStorage.setItem("compTitle", s.name);
      
    // })
  }
  
  getSolutionByVertical() {
    this.loading = false;
    const id = sessionStorage.getItem("compId");
    this.service.GetSolutionByVertical(id).subscribe((res) => {
      this.solutionByVertical = res;
      this.loading = false;
    });
  }
  getResourcesCount() {
    const id = sessionStorage.getItem("compId");
    this.service.GetResourcesCount(id).subscribe((res) => {
      this.resourceCount = res;
    }
    )
  }

  getCertificateCount() {
    const id = sessionStorage.getItem("compId");
    this.service.getCertificateCount(id, 0).subscribe((res) => {
      this.certificationCount = res.data.completedCertificateCount;
    });
  }
  maturity_portal() {
    var url = this.router.url.split('/');
    var name = url[3].replace(/%20/g, ' ');
    this.router.navigate([`Home/CMF Portal/${name}/Service-Line-Maturity-Measures`]);
  }
  // call() {

  //   this.subcomp = this.intialsubcomp;

  //   this.getcompetencyinsight();

  // }

  // updateSubcomp() {

  //   this.subcomp = this.subcompname;

  //   this.getcompetencyinsight();

  // }
  insightsarray: Array<any> = [];

  getcompetencyinsight() {
    if (this.id == null) {
      this.id = sessionStorage.getItem("compId")
    }
    if (this.subcomp == null) {
      this.subcomp = sessionStorage.getItem("SubcompTitle")
    }
    this._service.GetCompetencyInsightCount(this.id, this.subcomp).subscribe((res) => {
      this.data = res.data;

      this.insights();

    })


  }

  insights() {

    this.insightsarray = this.insightsDataArray(this.data)
  }



  private insightsDataArray(data: any): { label: string; value: number }[] {

    const insightsarray = [];

    for (const key in data) {

      if (data.hasOwnProperty(key)) {

        insightsarray.push({ label: key, value: data[key] });

      }

    }

    return insightsarray;

  }

  labelMappings = {
    totalCount: 'Resources Available',

  };

  getCompetencyDetails() {

    this._service.getCompetencies().subscribe((res) => {

      this.data = res.data;

      const matchedCompetency = this.data.find(

        (item: any) => item.id === this.id

      );

      if (matchedCompetency) {

        this.competencyData.competencyName = matchedCompetency.name;

      }

    });

  }

  // private populateYearlyOptions() {

  //   const currentYear = new Date().getFullYear();

  //   const endYear = currentYear + 10;



  //   for (let year = currentYear; year <= endYear; year++) {

  //     this.yearlyOptions.push(year);

  //   }

  // }

  openDialogue() {
    this.showDialogue = true;
  }
  onYearChange() {
    this.year = Number(this.year);
  }

  onQuarterChange() {

    this.quarterNo = Number(this.quarterNo);

  }

  serviceLevel(subcompetencyLevelData: any) {

    this.subcompetencyLevelData = subcompetencyLevelData;

  }

  competencyLevel(competencyLevelData: any) {

    this.competencyLevelData = competencyLevelData;

  }

  orgComponent() {

    this.hideIt = !this.hideIt

    this.orgHideit = !this.orgHideit

    this.others.toggleMaximize(1)

  }
  // deselectSelectedCheckboxes() {
  //   this.checkboxesWidgets.forEach(checkbox => {
  //     if (checkbox.selected) {
  //       checkbox.selected = false;
  //     }
  //   });
  // }
  orgArrowBack() {
    this.router.navigate([`Home/Competencies/${this.compname}`])
  }


  // openDropdown() {
  //   this.maxIndex = true;
  //   this.showPopup = !this.showPopup;
  //   if (!this.applyKPIs || !this.applyWidgets) {
  //     this.getKPIs();
  //     this.getWidgets();
  //   }
  // }



  // printSelectedCheckboxesKPIs() {
  //   this.getWidgets();
  //   this.maxIndex = false;
  //   this.showPopup = !this.showPopup;
  //   const employeeId = parseInt(localStorage.getItem("Id"));
  //   const KPIs = []
  //   const Widgets = []
  //   for (let i of this.checkboxesKPIs) {
  //     if (i.selected) {
  //       KPIs.push(i.label);
  //     }
  //   }
  //   for (let i of this.checkboxesWidgets) {
  //     if (i.selected) {
  //       Widgets.push(i.label);
  //     }
  //   }
  //   this._service.SetSettingById(employeeId, KPIs, Widgets).subscribe(x => {
  //     this.Toaster.success("Successfully Applied");
  //     this.applyKPIs = true;
  //   },
  //     error => {
  //       this.getKPIs();
  //       this.getWidgets();
  //       this.Toaster.error("Something went wrong, Please try again");
  //     });
  // }
  // printSelectedCheckboxesWidgets() {
  //   this.getKPIs();
  //   this.maxIndex = false;
  //   this.showPopup = !this.showPopup;
  //   const employeeId = parseInt(localStorage.getItem("Id"));
  //   const KPIs = []
  //   const Widgets = []
  //   for (let i of this.checkboxesKPIs) {
  //     if (i.selected) {
  //       KPIs.push(i.label);
  //     }
  //   }
  //   for (let i of this.checkboxesWidgets) {
  //     if (i.selected) {
  //       Widgets.push(i.label);
  //     }
  //   }
  //   this._service.SetSettingById(employeeId, KPIs, Widgets).subscribe(x => {
  //     this.Toaster.success("Successfully Applied");
  //     this.applyWidgets = true;
  //   },
  //     error => {
  //       this.getKPIs();
  //       this.getWidgets();
  //       this.Toaster.error("Something went wrong, Please try again");
  //     });
  // }

  // displayIt(data: string): boolean {
  //   const found = this.checkboxesWidgets.some(name => name.label === data && name.selected);
  //   return found
  // }
  // displayKPIs(data: string): boolean {
  //   const found = this.checkboxesKPIs.some(name => name.label === data && name.selected)
  //   return found
  // }
  // checkedKPIs(value) {
  //   for (let i of this.checkboxesKPIs) {
  //     if (value == i.label) {
  //       if (i.selected) {
  //         return true;
  //       }
  //       else {
  //         return false;
  //       }
  //     }
  //   }
  // }
  // changeOfKPIs(event, value) {
  //   if (event) {
  //     for (let i of this.checkboxesKPIs) {
  //       if (value == i.label) {
  //         i.selected = true;
  //       }
  //     }
  //   }
  //   else {
  //     for (let i of this.checkboxesKPIs) {
  //       if (value == i.label) {
  //         i.selected = false;
  //       }
  //     }

  //   }

  // }
  // checkedWidgets(value) {
  //   for (let i of this.checkboxesWidgets) {
  //     if (value == i.label) {
  //       if (i.selected) {
  //         return true;
  //       }
  //       else {
  //         return false;
  //       }
  //     }
  //   }
  // }
  // getPartnerships() {
  //   this.Compservice.getPartnershipdetails().subscribe(
  //     response => {
  //       if (response && response.data) {
  //         this.dataSource = response.data.map((partnership) => ({
  //           logo: partnership.partnershipLogo,
  //           name: partnership.name
  //         }));
  //       }
  //     },
  //     error => {
  //       console.error('Error fetching partnership details:', error);
  //     }
  //   );
  // }
  // changeOfWidgets(event, value) {
  //   if (event) {
  //     for (let i of this.checkboxesWidgets) {
  //       if (value == i.label) {
  //         i.selected = true;
  //       }
  //     }
  //   }
  //   else {
  //     for (let i of this.checkboxesWidgets) {
  //       if (value == i.label) {
  //         i.selected = false;
  //       }
  //     }

  //   }

  // }
  // navigateToPartnershipGrid(): void {
  //   var url = this.router.url.split('/')
  //   var navurl = decodeURIComponent(url[3]) + '/partnership-grid';
  //   this.router.navigate([navurl]);
  // }
  // getKPIs() {
  //   this._service.getSettingsById(localStorage.getItem("Id")).subscribe(x => {
  //     this.filterdata = x.data;
  //     if (this.filterdata != null) {
  //       if (this.filterdata.kpIs != null) {
  //         for (let i of this.checkboxesKPIs) {
  //           const found = this.filterdata.kpIs.some(name => name === i.label);
  //           if (found) {
  //             i.selected = true;
  //           }
  //         }

  //       }

  //     }
  //     else {
  //       for (let i of this.checkboxesKPIs) {
  //         i.selected = true;
  //       }

  //     }
  //   });

  // }
  // getWidgets() {
  //   this._service.getSettingsById(localStorage.getItem("Id")).subscribe(x => {
  //     this.filterdata = x.data;
  //     if (this.filterdata != null) {
  //       if (this.filterdata.widgets != null) {
  //         for (let i of this.checkboxesWidgets) {
  //           const found = this.filterdata.widgets.some(name => name === i.label);
  //           if (found) {
  //             i.selected = true;
  //           }
  //         }
  //       }

  //     }
  //     else {
  //       for (let i of this.checkboxesWidgets) {
  //         i.selected = true;
  //       }
  //     }
  //   });

  // }
  closePopup() {
    this.showPopup = false;
  }

}
